export default "__VITE_ASSET__CRM7zrnP__"